import { useQuery } from "@tanstack/react-query";
import {
  searchSuggest,
  SEARCH_SUGGEST_KEY,
} from "../api/searchV2Api";
import type { SearchContext } from "../types";

export function useSearchSuggest(
  q: string,
  context?: SearchContext,
) {
  return useQuery({
    queryKey: [...SEARCH_SUGGEST_KEY, q, context],
    queryFn: ({ signal }) => searchSuggest(q, context, signal),
    enabled: q.length >= 2,
    select: (res) => res.data.payload.results,
    staleTime: 60_000,
  });
}
